module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pedido/costo-envio/costo-envio/costo-envio.component.scss
// module id = ./src/app/pedido/costo-envio/costo-envio/costo-envio.component.scss
// module chunks = main